import { render, staticRenderFns } from "./sport_data_setup.vue?vue&type=template&id=06d32667&scoped=true&"
import script from "./sport_data_setup.vue?vue&type=script&lang=js&"
export * from "./sport_data_setup.vue?vue&type=script&lang=js&"
import style0 from "./sport_data_setup.vue?vue&type=style&index=0&id=06d32667&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d32667",
  null
  
)

export default component.exports